import { Component, Input } from '@angular/core';

import { EmojiComponent } from '@core/symbol-legacy';
import { ButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-reaction-button',
  templateUrl: './reaction-button.component.html',
  styleUrls: ['./reaction-button.component.less'],
  imports: [ButtonComponent, EmojiComponent],
})
export class ReactionButtonComponent {
  @Input() public reaction: string;
  @Input() public counter: number;
  @Input() public isActive: boolean;
}
